export default (str: string): string => str.charAt(0).toLowerCase() + str.slice(1);
